import React, { Component } from 'react';
import axios from "axios";
import moment from 'moment';
import {
    Alert,
    Box,
    Button,
    Chip,
    Divider,
    FormControl,
    Grid,
    InputLabel,
    LinearProgress,
    MenuItem,
    Paper,
    Select,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from '@mui/material';
import { Refresh as RefreshIcon } from '@mui/icons-material';
import Api from '../../customlib/Api';
import Global from '../../customlib/Global';
import DateRangePickerRich from '../../customlib/DateRangePickerRich';

const PERSON_INCHARGE_OPTIONS = ["Mitra", "Sales", "Tele", "Product", "Sistem", "Purchasing"];

// Palet warna berbeda untuk tiap item summary, dipakai berurutan/berputar
// mengikuti banyaknya kategori dinamis yang dikembalikan API.
const SUMMARY_COLORS = [
    { bg: "#e3f2fd", color: "#1565c0" },
    { bg: "#fce4ec", color: "#ad1457" },
    { bg: "#fff3e0", color: "#ef6c00" },
    { bg: "#e8f5e9", color: "#2e7d32" },
    { bg: "#ede7f6", color: "#5e35b1" },
    { bg: "#fbe9e7", color: "#d84315" },
    { bg: "#e0f7fa", color: "#00838f" },
    { bg: "#fffde7", color: "#f9a825" },
    { bg: "#f1f8e9", color: "#558b2f" },
    { bg: "#e8eaf6", color: "#3949ab" },
    { bg: "#fce4ec", color: "#c2185b" },
    { bg: "#e0f2f1", color: "#00695c" },
    { bg: "#f9fbe7", color: "#9e9d24" },
    { bg: "#efebe9", color: "#6d4c41" },
    { bg: "#eceff1", color: "#455a64" },
    { bg: "#f3e5f5", color: "#7b1fa2" },
    { bg: "#e1f5fe", color: "#0277bd" },
    { bg: "#fbe9e7", color: "#bf360c" },
    { bg: "#f0f4c3", color: "#827717" },
    { bg: "#d7ccc8", color: "#4e342e" },
];

class CsReportMonitoringIssueCo extends Component {
    state = {
        startDate: moment().tz("asia/jakarta").subtract(30, "days"),
        endDate: moment().tz("asia/jakarta"),
        personInchargeCategory: "",
        summary: [],
        list: [],
        loading: false,
        error: "",
    }

    componentDidMount() {
        this.load();
    }

    load = () => {
        this.setState({ loading: true, error: "" }, () => {
            const params = {
                startDate: this.state.startDate.format("Y-M-D"),
                endDate: this.state.endDate.format("Y-M-D"),
                personInCharge: this.state.personInchargeCategory || null,
            };

            axios
                .post(Api.csTicketMonitoringIssueCo(params), params, Api.getRequestHeader())
                .then((response) => {
                    const data = response.data;
                    if (data.success === true) {
                        this.setState({
                            loading: false,
                            summary: data.data?.summary || [],
                            list: data.data?.list || [],
                        });
                    } else {
                        this.setState({
                            loading: false,
                            summary: [],
                            list: [],
                            error: data.message || "Gagal memuat data monitoring issue CO.",
                        });
                    }
                })
                .catch((error) => {
                    this.setState({
                        loading: false,
                        summary: [],
                        list: [],
                        error: error.response?.data?.message || error.message || "Terjadi kesalahan saat memuat data.",
                    });
                    console.error("There was an error!", error);
                });
        });
    }

    handleDateChanged = (dateRange) => {
        if (dateRange && dateRange[0] && dateRange[1]) {
            this.setState({ startDate: dateRange[0], endDate: dateRange[1] }, this.load);
        }
    }

    handleFilterChanged = (event) => {
        this.setState({ personInchargeCategory: event.target.value }, this.load);
    }

    // Samakan warna pill kategori di tabel dengan warna chip summary di baris 2.
    // Kategori yang tidak muncul di summary tetap dapat warna stabil via hash nama kategori.
    getCategoryColor = (category) => {
        const idxInSummary = this.state.summary.findIndex((s) => s.person_incharge === category);
        if (idxInSummary !== -1) {
            return SUMMARY_COLORS[idxInSummary % SUMMARY_COLORS.length];
        }
        let hash = 0;
        for (let i = 0; i < category.length; i++) {
            hash = (hash * 31 + category.charCodeAt(i)) >>> 0;
        }
        return SUMMARY_COLORS[hash % SUMMARY_COLORS.length];
    }

    render() {
        const { summary, list, loading, personInchargeCategory, error } = this.state;

        return (
            <Box width={"100%"}>
                {error && (
                    <Alert
                        severity="error"
                        onClose={() => this.setState({ error: "" })}
                        sx={{ mb: 2 }}
                    >
                        {error}
                    </Alert>
                )}

                {/* === Baris 1 : Filter === */}
                <Grid container spacing={1}>
                    <Grid item xs={4}></Grid>
                    <Grid item xs={4} textAlign={"right"}>
                        <FormControl fullWidth size="small">
                            <InputLabel id="person-incharge-category-label">Kategori Penanggung Jawab</InputLabel>
                            <Select
                                labelId="person-incharge-category-label"
                                label="Kategori Penanggung Jawab"
                                value={personInchargeCategory}
                                onChange={this.handleFilterChanged}
                                sx={{textAlign: "left"}}
                                size='small'
                            >
                                <MenuItem value="">Semua</MenuItem>
                                {PERSON_INCHARGE_OPTIONS.map((opt) => (
                                    <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={1} textAlign={"left"}>
                        <Box sx={{ mt: "10px" }}>Tanggal : </Box>
                    </Grid>
                    <Grid item xs={2}>
                        <Box sx={{ mt: "5px" }}>
                            <DateRangePickerRich title={"Tanggal Tiket"} startDate={this.state.startDate} endDate={this.state.endDate} onDateChanged={this.handleDateChanged} />
                        </Box>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            startIcon={<RefreshIcon fontSize="small" />}
                            onClick={this.load}
                            disabled={loading}
                            sx={{ mt: "3px", textTransform: "none" }}
                        >
                            Refresh
                        </Button>
                    </Grid>
                </Grid>

                {
                    loading ? <LinearProgress sx={{ mt: "10px", mb: "10px" }} /> : <Divider sx={{ mt: "10px", mb: "10px" }} />
                }

                {/* === Baris 2 : Summary === */}
                <Grid container spacing={1.5} sx={{ mb: 2 }}>
                    {summary.length === 0 && !loading && (
                        <Grid item xs={12}>
                            <Typography variant="body2" color="text.secondary">
                                Tidak ada data summary.
                            </Typography>
                        </Grid>
                    )}
                    {summary.map((item, index) => {
                        const palette = SUMMARY_COLORS[index % SUMMARY_COLORS.length];
                        return (
                            <Grid item key={item.person_incharge ?? index}>
                                <Box
                                    sx={{
                                        minWidth: 130,
                                        borderRadius: "10px",
                                        bgcolor: palette.bg,
                                        color: palette.color,
                                        px: 2,
                                        py: 1.5,
                                        textAlign: "center",
                                    }}
                                >
                                    <Typography variant="h5" fontWeight={700} sx={{ lineHeight: 1.2 }}>
                                        {item.count}
                                    </Typography>
                                    <Typography variant="caption" fontWeight={600}>
                                        {item.person_incharge}
                                    </Typography>
                                </Box>
                            </Grid>
                        );
                    })}
                </Grid>

                {/* === Baris 3 : Table === */}
                <TableContainer component={Paper} variant="outlined">
                    <Table size="small">
                        <TableHead>
                            <TableRow sx={{ bgcolor: "#f5f5f5" }}>
                                <TableCell><strong>Tanggal</strong></TableCell>
                                <TableCell><strong>Ticket/CO</strong></TableCell>
                                <TableCell><strong>Issue CO (Asal)</strong></TableCell>
                                <TableCell><strong>Kategori Penanggung Jawab</strong></TableCell>
                                <TableCell><strong>Catatan</strong></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {list.length === 0 && !loading && (
                                <TableRow>
                                    <TableCell colSpan={5} align="center">
                                        <Typography variant="body2" color="text.secondary" sx={{ py: 2 }}>
                                            Tidak ada data tiket.
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            )}
                            {list.map((row) => (
                                <TableRow key={row.id} hover>
                                    <TableCell>{Global.formatDateTimeToStrFormat(row.created_at, "DD-MM-YYYY HH:mm")}</TableCell>
                                    <TableCell sx={{ fontFamily: "monospace" }}>{row.ticket_number}</TableCell>
                                    <TableCell>{row.co_issue || "-"}</TableCell>
                                    <TableCell>
                                        {row.person_incharge_category ? (
                                            <Chip
                                                label={row.person_incharge_category}
                                                size="small"
                                                sx={{
                                                    fontWeight: 600,
                                                    bgcolor: this.getCategoryColor(row.person_incharge_category).bg,
                                                    color: this.getCategoryColor(row.person_incharge_category).color,
                                                }}
                                            />
                                        ) : "-"}
                                    </TableCell>
                                    <TableCell>{row.notes || "-"}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        );
    }
}

export default CsReportMonitoringIssueCo;
